jQuery(document).ready(function() {

    // Function to change the text of the product-form--atc-button
    // function changeButtonText() {
    //     const atcButton = document.querySelector('.modal .product-form--atc-button');
    //     if (atcButton) {
    //         const buttonText = atcButton.querySelector('.atc-button--text');
    //         if (buttonText) {
    //             buttonText.textContent = 'Add to Quote';
    //         }
    //     }
    // }

    jQuery( ".announcement-right .quote-list-nav" ).on( "click", function( e ) {
      e.preventDefault();
    });
  
    document.addEventListener('DOMContentLoaded', function() {
      var button = document.querySelector('button[name="subscribe"]');
      if (button) {
        button.textContent = '>';
      }
    });

    // Check if we are on the specific collection page
    // if (window.location.href.indexOf('/collections/contractor') > -1) {
    //   // If we are on the "contractor" page, hide elements with a specific class
    //   var elementsToHide = document.querySelectorAll('.store-info');
    //   for (var i = 0; i < elementsToHide.length; i++) {
    //     elementsToHide[i].style.display = 'none';
    //   }
    // }

    // Check if we are on the all collections page
    if (window.location.href.indexOf('/collections/all') > -1) {
      var elementsToHide = document.querySelectorAll('.collection-info');
      for (var i = 0; i < elementsToHide.length; i++) {
        elementsToHide[i].style.display = 'none';
      }
    }
    
    // Function to monitor changes in the DOM and react to the appearance of the modal
    function observeModal() {
        const modal = document.querySelector('.modal');
        if (modal) {
            // If the modal is found, change the button text
            changeButtonText();
        }
    }
    
    // Add an event listener to the document for click events using event delegation
    document.addEventListener('click', function (event) {
        if (event.target.classList.contains('productitem--action-trigger')) {
            // Code to dynamically generate and display the modal
            // You may need to modify this part based on how you're generating the modal
            // ...
    
            // After the modal is displayed, change the button text
            observeModal();
        }
    });
    
    // Set up a mutation observer to detect changes in the DOM
    const observer = new MutationObserver(observeModal);
    
    // Start observing changes in the document body
    observer.observe(document.body, { childList: true, subtree: true });
  
    // Create the new div element
    var newDiv = $('<div class="d-flex align-items-center mb-4">' +
        '<div class="red-line me-3 ms-0"></div>' +
        '<div class="sp-heading text-uppercase fw-normal">What We Do</div>' +
        '</div>');

    // Find the existing h2 element
    var existingH2 = $('#shopify-section-template--14725089067085__318942fb-5779-45a5-80d4-22cd50c6a9bb .shoppable-image__text-box-title');

    // Insert the new div element before the existing h2 element
    existingH2.before(newDiv);

    var newContent = `
      <div class="hero-btns">
        <p class='text-white fs-5'>SAFE-T-PROOF™ is your dedicated partner in advanced earthquake preparedness and safety. From humble beginnings, we've grown into a global leader, committed to safeguarding lives and creating "Safer Spaces."</p>
      </div>
    `;
    
    // Find the specific element and set its content
    var element = $('body.template-page .shoppable-image__text-box-content');
    if (element.length > 0) {
      element.html(newContent);
    }

    jQuery("#shopify-section-template--14725089067085__1b4dccaf-0600-4b26-80d0-f8ee68f21501 h2").remove();
    jQuery("#shopify-section-template--14725089067085__318942fb-5779-45a5-80d4-22cd50c6a9bb h1").remove();
    jQuery(".shoppable-image__text-box-content .d-flex:first-of-type").remove();

    // Quick View - Select the button element by its class
    var button = $(".productitem--action-trigger.button-secondary");
    
    // Change the text of the button
    button.text("Quick View");

    // Quote List - Select the button element by its class
    // var button = $(".productitem--action-trigger.productitem--action-atc.button-primary");
    
    // Change the text of the button
    // button.find(".atc-button--text").text("Add to Quote List");

    jQuery(".overlay-red").fadeOut();
    console.log("fadeout");
  
    jQuery('.mosiac-container').mouseenter(function() {
        console.log("enter");
        jQuery(this).find('.overlay-red').fadeIn();
    });

    // Function to fadeOut overlay on mouseleave
    jQuery('.mosiac-container').mouseleave(function() {
        console.log("exit");
        jQuery(this).find('.overlay-red').fadeOut();
    });

    jQuery("#shopify-section-template--14725089067085__318942fb-5779-45a5-80d4-22cd50c6a9bb .shoppable-image__section-content-wrapper").addClass("row safetproof-your-home align-items-center");
    jQuery("#shopify-section-template--14725089067085__318942fb-5779-45a5-80d4-22cd50c6a9bb .shoppable-image__text-box-wrapper").addClass("col-md-7 p-5");

    jQuery('.accordion-button').on('click', function () {
        // Toggle the visibility of chevron icons when an accordion item is clicked
        jQuery(this).find('.fa-chevron-down, .fa-chevron-up').toggleClass('d-none');
    });

    // Home Page Rotation
    // Content data
    const categories = ["Lab", "Hospital", "Office", "House"];
    const contentData = {
        Lab: {
            imageSrc: "https://cdn.shopify.com/s/files/1/0084/4657/4669/files/sp_safetproof_your_lab.webp?v=1695849501",
            bulletpoints: [
                "Premium Appliance Straps",
                "Custom Solutions",
                "ICC Certified"
            ]
        },
        Hospital: {
            imageSrc: "https://cdn.shopify.com/s/files/1/0084/4657/4669/files/sp_safetproof_your_hospital.webp?v=1695849501",
            bulletpoints: [
                "Premium Appliance Straps",
                "Custom Solutions",
                "ICC Certified"
            ]
        },
        Office: {
            imageSrc: "https://cdn.shopify.com/s/files/1/0084/4657/4669/files/sp_safetproof_your_commercial.webp?v=1695849502",
            bulletpoints: [
                "Premium Appliance Straps",
                "Office Safety Solutions",
                "Cabinet Latches and More"
            ]
        },
        House: {
            imageSrc: "https://cdn.shopify.com/s/files/1/0084/4657/4669/files/safe_t_proof_your_house.webp?v=1694183552",
            bulletpoints: [
                "Furniture Anti-Tip Straps",
                "Earthquake Fastening Solutions",
                "Customized Home Safety Solutions"
            ]
        }
    };

    // Initialize currentIndex
    let currentIndex = 0;
    
    // Function to fade out an element
    function fadeOutElement(elementId) {
        const element = document.getElementById(elementId);
        element.classList.remove("fade-in");
        element.classList.add("fade-out");
    }
    
    // Function to fade in an element
    function fadeInElement(elementId) {
        const element = document.getElementById(elementId);
        element.classList.remove("fade-out");
        element.classList.add("fade-in");
    }
    
    // Function to update content
    function updateContent() {
        // Fade out elements
        fadeOutElement("content-category");
        fadeOutElement("content-image");
        fadeOutElement("bulletpoint-1");
        fadeOutElement("bulletpoint-2");
        fadeOutElement("bulletpoint-3");
    
        // After a short delay, fade in elements with updated content
        setTimeout(() => {
            // Get the next category
            const category = categories[currentIndex];
            const data = contentData[category];
    
            // Update text and image source
            document.getElementById("content-category").textContent = category;
            document.getElementById("content-image").src = data.imageSrc;
    
            // Update bulletpoints (bp-1, bp-2, bp-3)
            const bulletpoints = data.bulletpoints;
            for (let i = 1; i <= 3; i++) {
                document.getElementById("bulletpoint-" + i).textContent = bulletpoints[i - 1];
            }
    
            // Increment currentIndex
            currentIndex = (currentIndex + 1) % categories.length;
    
            // Fade in elements
            fadeInElement("content-category");
            fadeInElement("content-image");
            fadeInElement("bulletpoint-1");
            fadeInElement("bulletpoint-2");
            fadeInElement("bulletpoint-3");
        }, 500); // Adjust the delay (in milliseconds) as needed for a smooth transition
    }

  // Set up the timer to update content every 3 seconds
  setInterval(updateContent, 5000);
  
  // Initial content update
  updateContent();
  
  // window.addEventListener('scroll', function() {
  //     // Check screen width and scroll position
  //     if (window.innerWidth >= 1023 && window.scrollY >= 55) {
  //         // Hide the element
  //         jQuery("header").addClass("header-sticky");
  //         document.querySelector('.container-announcement').style.display = 'none';
  //         document.querySelector('.site-header-main').style.display = 'none';
  //     } else {
  //         // Show the element
  //         document.querySelector('.container-announcement').style.display = 'block';
  //         document.querySelector('.site-header-main').style.display = 'block';
  //     }
  // });
  
});



















